import * as Types from './types';

export function setSelectedSite(selectedSite?: Site) {
  return {
    type: Types.ActionTypes.SET_SELECTED_SITE,
    selectedSite
  }
}